export function improveRelativeResult(result) {
  if (result.meta.initialValue.units === 'mg') {
    result.meta.sampleMass = result.meta.initialValue;
    return;
  }

  if (result.meta.initialValue.units !== '%') return;
  if (result.meta.zones?.length < 1) return;

  const firstZone = result.meta.zones[0];

  if (firstZone.massLoss.units !== 'mg') return;
  if (Math.abs(firstZone.massLoss.value) < 0.0001) return;

  result.meta.sampleMass = {
    value: firstZone.massLoss.value / firstZone.relativeMassLoss,
    units: firstZone.massLoss.units,
  };

  // we can now calculate the 'y' variable
  const ratio = result.meta.sampleMass.value / result.meta.initialValue.value;

  const percentData = result.variables['%'].data;
  result.variables.y = {
    label: 'Weight',
    units: result.meta.sampleMass.units,
    data: [],
  };
  for (let i = 0; i < percentData.length; i++) {
    result.variables.y.data.push(percentData[i] * ratio);
  }
}
